export default __webpack_public_path__ + "static/case2_img_5@2x-6dae8e3bb24873a03a3bc336465933b9.webp";